export const SCHEMAS = {
  home_hero: {
    fields: [
      { k: "eyebrow", label: "Eyebrow line" },
      { k: "title_lead", label: "Heading — lead" },
      { k: "title_highlight", label: "Heading — gold highlight" },
      { k: "title_tail", label: "Heading — second line" },
      { k: "subtitle", label: "Sub-text", type: "textarea" },
      { k: "cta_primary_label", label: "Primary button label" },
      { k: "cta_primary_to", label: "Primary button link" },
      { k: "cta_secondary_label", label: "Secondary button label" },
      { k: "cta_secondary_to", label: "Secondary button link" },
    ],
  },
  home_pillars: {
    items: {
      label: "Pillar", title: "title",
      fields: [
        { k: "title", label: "Title" },
        { k: "icon", label: "Icon", type: "select", options: ["Users", "HeartHandshake", "Sprout"] },
        { k: "body", label: "Body", type: "textarea" },
      ],
    },
  },
  history_timeline: {
    items: {
      label: "Timeline entry", title: "year",
      fields: [
        { k: "year", label: "Year / Era" },
        { k: "title", label: "Title" },
        { k: "body", label: "Body", type: "textarea" },
        { k: "image", label: "Image", type: "image" },
        { k: "caption", label: "Image caption" },
      ],
    },
  },
  history_figures: {
    items: {
      label: "Figure", title: "name",
      fields: [
        { k: "name", label: "Name" },
        { k: "note", label: "Note", type: "textarea" },
      ],
    },
  },
  freemasonry_faqs: {
    items: {
      label: "Question", title: "q",
      fields: [
        { k: "q", label: "Question" },
        { k: "a", label: "Answer", type: "textarea" },
      ],
    },
  },
  visit_details: {
    fields: [
      { k: "address", label: "Address" },
      { k: "meeting", label: "Meeting day" },
      { k: "tyling", label: "Tyling time" },
      { k: "dress", label: "Dress code" },
      { k: "emailSecretary", label: "Secretary email" },
      { k: "emailMaster", label: "Worshipful Master email" },
    ],
  },
  article: {
    fields: [
      { k: "title", label: "Title" },
      { k: "excerpt", label: "Excerpt (shown on listings)", type: "textarea" },
      { k: "publish_date", label: "Publish date", type: "date" },
      { k: "cover_image", label: "Cover image", type: "image" },
      { k: "body", label: "Body", type: "richtext" },
      { k: "attachments", label: "Attachments", type: "attachments" },
    ],
  },
};

export const schemaFor = (item) => (item.type === "article" ? SCHEMAS.article : SCHEMAS[item.key]);

export const PUBLIC_PATH = {
  Home: "/", History: "/history", Freemasonry: "/freemasonry", Visit: "/visit", News: "/news",
};
